export enum StickyColor {
  Blue = "#8fb1df",
  Violet = "#dfa4dc",
  Orange = "#ffca94",
  Green = "#a3df93",
}
